import { useDeleteGroupMutation } from 'api/ordering-service/ordering-service';
import { TransformGroupResult } from 'api/ordering-service/ordering-service.types';
import ConfirmationDrawer from 'components/drawers/confirmation-drawer/confirmation-drawer.component';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

type GroupDeleteDrawerProps = {
  open: boolean;
  close: () => void;
  drawerData: Partial<TransformGroupResult>;
};

const GroupDeleteDrawer = ({
  open,
  close,
  drawerData,
}: GroupDeleteDrawerProps) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [deleteGroup] = useDeleteGroupMutation();

  const onConfirmationValid = async () => {
    try {
      await deleteGroup({
        groupId: drawerData?.groupId,
      }).unwrap();

      enqueueSnackbar(
        t('GroupsDataGrid.actions.delete.alertMessage', {
          groupTitle: drawerData?.title,
        }),
        { severity: 'success' },
      );
      close();
    } catch (_e) {}
  };

  return (
    <ConfirmationDrawer
      open={open}
      close={close}
      subtitle={t('drawer.groupDeleteDrawer.subtitle', {
        groupTitle: drawerData?.title,
      })}
      submitButtonLabel={t('drawer.groupDeleteDrawer.submitButtonLabel')}
      onValid={onConfirmationValid}
      cancel={close}
      color="error"
    />
  );
};

export default GroupDeleteDrawer;
